import React from 'react';
import { Button } from '../../ui/button';
import { Check, X } from 'lucide-react';

interface VerificationSetupProps {
  verificationCode: string;
  error: string;
  onVerificationCodeChange: (code: string) => void;
  onCancel: () => void;
  onVerify: () => Promise<void>;
}

export const VerificationSetup: React.FC<VerificationSetupProps> = ({
  verificationCode,
  error,
  onVerificationCodeChange,
  onCancel,
  onVerify
}) => {
  return (
    <div className="space-y-4 p-4 bg-gray-800/30 rounded-lg">
      <div className="space-y-2">
        <div className="text-sm font-medium text-white">2. Verify Code</div>
        <div className="text-sm text-gray-400">
          Enter the 6-digit code from your authenticator app to verify and enable 2FA
        </div>
      </div>

      <div className="space-y-2">
        <input
          type="text"
          maxLength={6}
          className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
          placeholder="Enter 6-digit code"
          value={verificationCode}
          onChange={(e) => onVerificationCodeChange(e.target.value.replace(/\D/g, ''))}
        />
      </div>

      {error && (
        <div className="text-sm text-red-500 bg-red-500/10 px-4 py-2 rounded-lg">
          {error}
        </div>
      )}

      <div className="flex space-x-3">
        <Button
          variant="outline"
          className="flex-1"
          onClick={onCancel}
        >
          <X className="h-4 w-4 mr-2" />
          Cancel
        </Button>
        <Button
          className="flex-1"
          onClick={onVerify}
          disabled={verificationCode.length !== 6}
        >
          <Check className="h-4 w-4 mr-2" />
          Verify and Enable
        </Button>
      </div>
    </div>
  );
};